function parseUrl(value) {
  try {
    return new URL(value);
  } catch {
    return null;
  }
}

function isLocalhostLikeHostname(hostname) {
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1';
}

function isLocalhostLikeUrl(value) {
  const parsed = parseUrl(value);
  return isLocalhostLikeHostname(parsed?.hostname || '');
}

async function shouldRetryLocalProxyAuthResponse(response, target) {
  if (!isLocalhostLikeUrl(target) || ![401, 403].includes(response?.status)) {
    return false;
  }

  const contentType = response.headers?.get?.('Content-Type') || response.headers?.get?.('content-type') || '';
  if (!contentType.includes('application/json')) {
    return false;
  }

  try {
    const body = await response.clone().json();
    const details = [
      body?.detail,
      body?.error,
      body?.message,
    ]
      .flat()
      .filter(Boolean)
      .join(' ')
      .toLowerCase();

    return details.includes('authentication is required')
      || details.includes('missing or invalid authorization header')
      || details.includes('invalid or expired token')
      || (
        details.includes('invalid key')
        && (
          details.includes('header format')
          || details.includes('<key_id>:<key_secret>')
        )
      );
  } catch {
    return false;
  }
}

export async function shouldRetryProxyResponse(response, target) {
  if ([408, 502, 503, 504, 522, 523, 524].includes(response?.status)) {
    return true;
  }

  return shouldRetryLocalProxyAuthResponse(response, target);
}
